import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Popconfirm, Row, Col, Form, Table } from "antd";
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { getListCustomerActive } from '../../../redux/actions/customerActions';
import { getRelationshipTypeActive } from '../../../redux/actions/RelationshipTypeActions';
import BaseSelect from '../../../components/Elements/BaseSelect';

const TreatmentSheetItems = (props) => {

    const { form, listName, groupName, required } = props;
    const [customerQuery, setCustomerQuery] = useState('');

    const relationshipType = useSelector((state) => state.RelationshipTypeReducer.relationshipTypeActiveList);
    const customers = useSelector((state) => state.customerReducer.activeList.items);
    const pagination = useSelector((state) => state.customerReducer.activeList.pagination);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getListCustomerActive());
        dispatch(getRelationshipTypeActive());
    }, []);

    useEffect(() => {
        const currentData = form.getFieldValue([groupName, listName]);

        if (!currentData || currentData.length === 0) {
            form.setFieldsValue({
                [groupName]: {
                    [listName]: [{
                        related_id: null,
                        relationship_type: null,
                        relationship_type_inverse: null
                    }]
                }
            });
        } else {
            // Có dữ liệu → gán lại để Form.List render
            form.setFieldsValue({
                [groupName]: {
                    [listName]: currentData
                }
            });
        }
    }, [form, groupName, listName]);

    const onSearchCustomer = (val) => {
        setCustomerQuery(val);
        dispatch(getListCustomerActive({ keyword: val }));
    };

    const handleCustomerScroll = (e) => {
        dispatch(getListCustomerActive({ keyword: customerQuery, page: pagination.currentPage + 1 }));
    }

    return (
        <div style={{ paddingBottom: 100 }} className='mt-3'>
            <div className='chingo-normal-title'>Quan hệ gia đình</div>
            <Row gutter={16} className='mt-2'>
                <Col xs={24} md={24}>
                    <Form.List name={[groupName, listName]}>
                        {(fields, { add, remove }) => (
                            <>
                                <Table
                                    dataSource={fields}
                                    columns={[
                                        {
                                            title: "Họ và tên",
                                            dataIndex: "related_id",
                                            render: (_, __, index) => (
                                                <Form.Item
                                                    name={[index, "related_id"]}
                                                    rules={[{ required: required, message: "Bắt buộc chọn" }]}
                                                >
                                                    <BaseSelect
                                                        options={customers || []}
                                                        optionValue="id"
                                                        optionLabel="full_name"
                                                        additionalLabel="phone"
                                                        additionalLabel2="code"
                                                        isCustomerList={true}
                                                        showSearch={true}
                                                        placeholder="Nhập mã, tên, 3 số cuối sđt của khách hàng"
                                                        onSearch={(val) => onSearchCustomer(val)}
                                                        onScrollEnd={(e) => handleCustomerScroll(e)}
                                                        allowClear={true}
                                                    />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: "Quan hệ",
                                            dataIndex: "relationship_type",
                                            width: "150px",
                                            render: (_, __, index) => (
                                                <Form.Item
                                                    name={[index, "relationship_type"]}
                                                    rules={[{ required: required, message: "Bắt buộc chọn" }]}
                                                >
                                                    <BaseSelect
                                                        options={relationshipType || []}
                                                        optionValue="id"
                                                        optionLabel="name"
                                                        placeholder="Chọn"
                                                        style={{ width: '100%' }}
                                                        showSearch={true}
                                                    />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: "Quan hệ ngược",
                                            dataIndex: "relationship_type_inverse",
                                            width: "150px",
                                            render: (_, __, index) => (
                                                <Form.Item
                                                    name={[index, "relationship_type_inverse"]}
                                                    rules={[{ required: required, message: "Bắt buộc chọn" }]}
                                                >
                                                    <BaseSelect
                                                        options={relationshipType || []}
                                                        optionValue="id"
                                                        optionLabel="name"
                                                        placeholder="Chọn"
                                                        style={{ width: '100%' }}
                                                        showSearch={true}
                                                    />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: "#",
                                            dataIndex: "actions",
                                            width: "50px",
                                            render: (_, __, index) => (
                                                <Popconfirm
                                                    title="Xóa dòng này?"
                                                    onConfirm={() => remove(index)}
                                                    placement="topLeft"
                                                >
                                                    <DeleteOutlined className='delete-icon' />
                                                </Popconfirm>
                                            )
                                        }
                                    ]}
                                    rowKey="key"
                                    pagination={false}
                                    size='small'
                                    bordered={false}
                                    locale={{ emptyText: "Chưa có dữ liệu" }}
                                    scroll={{ x: 'max-content' }}
                                />
                                <Button
                                    type="primary"
                                    size='default'
                                    className='w-100 mt-2'
                                    onClick={() => add({
                                        related_id: null,
                                        relationship_type: null,
                                        relationship_type_inverse: null
                                    })}
                                    icon={<PlusOutlined />}
                                >
                                    Thêm dòng mới
                                </Button>
                            </>
                        )}
                    </Form.List>
                </Col>
            </Row>
        </div>
    );
};

export default TreatmentSheetItems;